import { render, staticRenderFns } from "./Anav.vue?vue&type=template&id=54da4061&scoped=true"
import script from "./Anav.vue?vue&type=script&lang=js"
export * from "./Anav.vue?vue&type=script&lang=js"
import style0 from "./Anav.vue?vue&type=style&index=0&id=54da4061&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da4061",
  null
  
)

export default component.exports